import React, { useEffect, useRef, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { cloneDeep } from 'lodash'
import { Checkbox, Col, Divider, message, Row, Space } from 'antd'
import { PrimaryButton } from 'Components/button'
import {
  DiscountType,
  DocumentConfigKey,
  menuDiscountType,
  menuQuotationDeliveryType,
  QuotationStatus,
  VAT_TYPE,
  VAT_TYPE_TEXT,
} from 'helpers/constanst'
import {
  isFormRequired,
  isFormError,
  formValidation,
  isAfter,
  getPriceConfigsMenuSelect,
  validateEmail,
  numberWithComma,
  toDateQuery,
  getCustomerMenuSelect,
  currentDateTime,
  getConfigByKey,
} from 'helpers/format'
import {
  CreateQuotationForm,
  CreateQuotationReq,
  ProductQuotationForm,
  QuotationDetailReq,
  QuotationProduct,
  UpdateQuotationReq,
} from 'Store/quotation/types'
import { createQuotationAPI, getQuotationDetailAPI, updateQuotationAPI } from 'Store/quotation/api'
import {
  selectQuotationActionEvent,
  selectQuotationDetail,
  selectQuotationDetailEvent,
  selectRejectData,
} from 'Store/quotation/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { AppInput, AppSelect, AppTextArea, FormItem } from 'Components/form'
import EventModal from 'Components/modal/EventModal'
import { clearEventAction } from 'Store/quotation/actions'
import LoadingView from 'Components/modal/LoadingView'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import AppDateItem from 'Components/form/AppDateItem'
import ProductsTable from './components/ProductsTable'
import { selectAllSupplierList } from 'Store/supplier/selector'
import moment from 'moment'
import { ConfirmDailog } from 'Components/modal'
import DetailHeader from './components/DetailHeader'
import { selectDatas } from 'Store/config/selector'
import LinkText from 'Components/text/LinkText'
import QuotationPDF from './components/QuotationPDF'
import { SaleOrderCustomerListReq } from 'Store/saleorder-customer/types'
import { allSaleOrderCustomerListAPI } from 'Store/saleorder-customer/api'
import { selectAllSaleOrderCustomerList } from 'Store/saleorder-customer/selector'
import { getStaffPermission } from 'helpers/account'
import { TableListPage } from 'Components/common/Table'
import ConfirmWithChild from 'Components/modal/ConfirmWithChild'
import { selectConfigList } from 'Store/pos/selector'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  mode: any
  id?: number
}

const QuotationDetailForm: React.FunctionComponent<Props> = props => {
  const {
    onCloseDrawer,
    visible,
    currentUser,
    event,
    onSuccess = () => {},
    id = 0,
    mode,
    detail,
    detailEvent,
    configs,
    customers,
    rejectData,
    configList,
  } = props

  const isCreateMode = mode === 'create'
  const requireFeild = [
    'name',
    'mobile',
    'address',
    'type',
    'products',
    'recipient_name',
    'recipient_mobile',
    'recipient_address',
    'delivery_date',
    'delivery_channel',
    'issuer_name',
  ]
  const initForm = {
    address: '',
    email: '',
    name: '',
    tax_address: '',
    tax_mobile: '',
    tax_name: '',
    tax_number: '',
    type: 'price_a',
    mobile: '',
    delivery_channel: '',
    delivery_date: '',
    discount: 0,
    discount_type: 'amount',
    issuer_name: '',
    issuer_note: '',
    products: [],
    quotation_no: '',
    reason: '',
    recipient_address: '',
    recipient_email: '',
    recipient_mobile: '',
    recipient_name: '',
    shipping_cost: 0,
    status: '',
    total_amount: 0,
    total_quantity: 0,
    is_tax: false,
    create_at: moment(),
  } as CreateQuotationForm
  const [formData, setFormData] = useState(cloneDeep(initForm))
  const [formError, setFormError] = useState([] as string[])
  const [draftFormError, setDrafFormError] = useState([] as string[])
  const [confirmCreateDialog, setConfirmCreateDialog] = useState(false)
  const [warningOverstockDialog, setWarningOverstockDialog] = useState(false)
  const quotationPDF = useRef(null as any)
  const quotationLitePDF = useRef(null as any)
  const isFranchise = currentUser?.activeMerchant?.is_fc === true
  const [updatedStatus, setUpdatedStatus] = useState(QuotationStatus.DRAFT as QuotationStatus)
  const permission = getStaffPermission()
  const hasOverstockPermission = permission && permission.includes('overstock')
  const hasNoneskuPermission = permission && permission.includes('none-sku')
  const hasProductDiscount = permission && permission.includes('quotation-product-discount')
  const dispatch = useDispatch()

  const configData = getConfigByKey(configList, DocumentConfigKey.VAT_TYPE)
  const config = (configData && configData?.config_value) || ''
  const isExcludeVat = config === VAT_TYPE.EX

  const configDataQu = getConfigByKey(configList, DocumentConfigKey.QUOTATION)
  const configShowVat =
    configDataQu && configDataQu?.config_value && JSON.parse(configDataQu?.config_value || '')
  const showVat = configShowVat?.enableTax || false

  useEffect(() => {
    // clear form data when user cloase drawer
    if (!visible) {
      setFormData(cloneDeep(initForm))
      setFormError([])
    }

    // get detail on "edit" mode
    if (visible && !isCreateMode && id > 0) {
      onGetDetail()
    } else {
      const lastIssuerName = localStorage.getItem('quotation_issuer_name')
      setFormData({ ...initForm, issuer_name: lastIssuerName || '' })
    }

    if (visible) {
      onGetCustomerList()
    }

    return () => {
      setFormData({ ...initForm })
    }
  }, [visible])

  useEffect(() => {
    if (mode === 'edit' && id > 0) {
      const products = cloneDeep(detail?.products || []).map(item => {
        if (item?.sale_item_type === 'overstock') {
          item.sale_item_type = ''
        }
        return item
      })
      const form = {
        create_at: detail?.created_at,
        delivery_channel: detail?.delivery_channel || '',
        delivery_date: detail?.delivery_date,
        discount: detail?.discount,
        discount_type: detail?.discount_type,
        issuer_name: detail?.issuer_name,
        address: detail?.customer?.address,
        email: detail?.customer?.email,
        issuer_note: detail?.issuer_note,
        name: detail?.customer?.name,
        products: products,
        quotation_no: detail?.quotation_no,
        reason: detail?.reason,
        recipient_address: detail?.recipient_address,
        recipient_email: detail?.recipient_email,
        recipient_mobile: detail?.recipient_mobile,
        recipient_name: detail?.recipient_name,
        shipping_cost: detail?.shipping_cost || 0,
        status: detail?.status,
        tax_address: detail?.customer?.tax_address,
        tax_mobile: detail?.customer?.tax_mobile,
        tax_name: detail?.customer?.tax_name,
        tax_number: detail?.customer?.tax_number,
        is_tax: detail?.is_tax || false,
        total_amount: detail?.total_amount,
        total_quantity: detail?.total_quantity,
        type: detail?.customer?.type,
        id: detail?.id,
        mobile: detail?.customer?.mobile,
      } as CreateQuotationForm
      setFormData({ ...cloneDeep(form) })
    }
  }, [detail])

  useEffect(() => {
    if (formError.length > 0) {
      validateForm()
    }
  }, [formData])

  // useEffect(() => {
  //   if (customers && customers.length > 0) {
  //     const cusInfo = customers[0]
  //     setFormData({
  //       ...formData,
  //       name: cusInfo.name || '',
  //       address: cusInfo.address,
  //       mobile: cusInfo.mobile,
  //       email: cusInfo.email,
  //       type: cusInfo.type,
  //       is_tax: cusInfo.is_tax,
  //       tax_name: cusInfo.tax_name,
  //       tax_number: cusInfo.tax_number,
  //       tax_mobile: cusInfo.tax_mobile,
  //       tax_address: cusInfo.tax_address,
  //     })
  //   }
  // }, [customers])

  const validateForm = () => {
    const error = formValidation(requireFeild, formData)

    if (formData.is_tax) {
      if (!formData?.tax_name) {
        error.push('tax_name')
      }
      if (!formData?.tax_number) {
        error.push('tax_number')
      }
      // if (!formData?.tax_mobile) {
      //   error.push('tax_mobile')
      // }
      if (!formData?.tax_address) {
        error.push('tax_address')
      }
    }

    if (formData.email) {
      if (!validateEmail(formData.email)) {
        error.push('email_format')
      }
    }

    if (formData.recipient_email) {
      if (!validateEmail(formData.recipient_email)) {
        error.push('recipient_email_format')
      }
    }

    setFormError([...error])
    return error.length > 0 ? false : true
  }

  const validateDraftForm = () => {
    const error = []

    if (!formData?.mobile) {
      error.push('mobile')
    }

    setDrafFormError([...error])
    return error.length > 0 ? false : true
  }

  const validateQuotationItem = () => {
    const error = cloneDeep(formError) as string[]
    if (!formData?.products || (formData.products && formData.products.length <= 0)) {
      error.push('products')
    }

    if (formData.products && formData.products.length > 0) {
      let wrongInfo = false
      let wrongStock = false
      formData.products.forEach(item => {
        if (
          !item.quantity ||
          item.quantity <= 0 ||
          !item.price ||
          item.price <= 0 ||
          item.title === '' ||
          (item.sale_item_type === 'none-sku' && item.unit === '')
        ) {
          wrongInfo = true
          return
        }
      })
      if (wrongInfo) {
        error.push('products_wrong')
      }

      formData.products.forEach(item => {
        if (item.quantity > item.current_stock) {
          if ((!hasOverstockPermission && item.sale_item_type !== 'none-sku') || isFranchise) {
            wrongStock = true
            return
          }
        }
      })
      if (wrongStock) {
        error.push('stock_wrong')
      }
    }
    setFormError([...error])
    return error.length > 0 ? false : true
  }

  const onSelectCustomer = (mobile: string) => {
    const result = customers && customers.find(item => item.mobile === mobile)
    setFormData({
      ...formData,
      address: result?.address || '',
      mobile: result?.mobile || '',
      name: result?.name || '',
      email: result?.email || '',
      type: result?.type || '',
      tax_address: result?.tax_address || '',
      tax_mobile: result?.tax_mobile || '',
      tax_name: result?.tax_name || '',
      tax_number: result?.tax_number || '',
    })
  }

  const saveIssueNameToStorage = (name: string) => {
    localStorage.setItem('quotation_issuer_name', name)
  }

  const onCreate = (status: QuotationStatus): void => {
    if (status !== QuotationStatus.DRAFT && !validateForm()) {
      return
    } else {
      if (!validateDraftForm()) {
        return
      }
    }
    if (status !== QuotationStatus.DRAFT) {
      if (!validateQuotationItem()) return
    }
    const reqBody = formatRequestParam(formData)
    const req: CreateQuotationReq = {
      ...reqBody,
      status: status,
      // username: userInfo?.username || '',
    }

    saveIssueNameToStorage(req.issuer.name)

    dispatch(createQuotationAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onConfirmCreate = () => {
    setUpdatedStatus(QuotationStatus.PENDING)
    if (id && id > 0) {
      onUpdate(QuotationStatus.PENDING)
    } else {
      onCreate(QuotationStatus.PENDING)
    }
  }

  const onRetryCreate = () => {
    setWarningOverstockDialog(false)
    if (id && id > 0) {
      onUpdate(updatedStatus)
    } else {
      onCreate(updatedStatus)
    }
  }

  const updateOverStockData = () => {
    const newForm = cloneDeep(formData)
    newForm &&
      newForm.products.map(item => {
        if (item.updated_flag) {
          item.sale_item_type = 'overstock'
        }
        return item
      })
    setFormData(newForm)
  }

  const onClickCreate = () => {
    if (!validateForm()) {
      message.warning('กรุณาระบุข้อมูลให้ถูกต้อง')
      return
    }
    if (!validateQuotationItem()) {
      message.warning('กรุณาระบุข้อมูลให้ถูกต้อง')
      return
    }
    setConfirmCreateDialog(true)
  }

  const onGetDetail = (): void => {
    const req: QuotationDetailReq = {
      id,
    }
    dispatch(getQuotationDetailAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onGetCustomerList = (): void => {
    const req: SaleOrderCustomerListReq = {
      page: 1,
      per_page: 10,
      all: true,
    }
    dispatch(
      allSaleOrderCustomerListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''),
    )
  }

  const onUpdate = (status: QuotationStatus): void => {
    if (status !== QuotationStatus.DRAFT && !validateForm()) {
      return
    } else {
      if (!validateDraftForm()) {
        return
      }
    }

    if (status !== QuotationStatus.DRAFT) {
      if (!validateQuotationItem()) return
    }
    const reqBody = formatRequestParam(formData)
    const req: UpdateQuotationReq = {
      ...reqBody,
      id,
      status: status,
      //username: userInfo?.username || '',
    }
    if (req?.delivery_date && req.delivery_date === detail?.delivery_date) {
      req.delivery_date = toDateQuery(moment(reqBody?.delivery_date, 'YYYY-MM-DD'))
    }

    saveIssueNameToStorage(req.issuer.name)
    dispatch(updateQuotationAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onUpdateData = (val: any, key: string) => {
    if (key === 'mobile' && val.length > 10) {
      return
    }

    if (key === 'tax_number' && val.length > 13) {
      return
    }

    if (key === 'discount' && formData.discount_type === DiscountType.PERCENT && val > 100) {
      val = 100
    }

    setFormData({
      ...formData,
      [key]: val,
    })
  }

  const onCopyCustomerData = () => {
    setFormData({
      ...formData,
      recipient_name: formData.name,
      recipient_mobile: formData?.mobile || '',
      recipient_address: formData.address,
      recipient_email: formData.email,
    })
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const updateCurrentData = () => {
    const newForm = cloneDeep(formData)
    newForm &&
      newForm.products.map(item => {
        const findUpdateData =
          rejectData?.products &&
          rejectData.products.find(
            updateData =>
              updateData?.updated_flag === true &&
              item.product_id === updateData?.product_id &&
              item.product_option_id === updateData?.product_option_id,
          )
        if (findUpdateData) {
          item.current_stock = findUpdateData?.current_stock || 0
          item.updated_flag = findUpdateData.updated_flag || false
          item.message = findUpdateData.message || ''
        } else {
          item.updated_flag = false
        }
        return item
      })
    setFormData(newForm)
  }

  const resetUpdatedFlag = () => {
    const newForm = cloneDeep(formData)
    newForm &&
      newForm.products.map(item => {
        item.updated_flag = false
        return item
      })
    setFormData(newForm)
  }

  const onEventSuccess = (): void => {
    if (rejectData) {
      clearEvent()
      updateCurrentData()
      setConfirmCreateDialog(false)
      setWarningOverstockDialog(true)
    } else {
      clearEvent()
      onSuccess()
      setConfirmCreateDialog(false)
    }
  }

  const isRequired = (name: string) => {
    return isFormRequired(requireFeild, name)
  }

  const isError = (name: string) => {
    return isFormError(formError, name)
  }

  const countTotal = () => {
    let amount = 0
    let price = 0
    formData.products &&
      formData.products.forEach(item => {
        const totalPrice = (item.quantity || 0) * (item.price || 0)
        amount += item.price
        price += totalPrice
      })
    return { amount, price }
  }

  const countฺBeforeDiscountTotal = () => {
    let amount = 0
    let price = 0
    formData.products &&
      formData.products.forEach(item => {
        const totalPrice = (item.quantity || 0) * (item.price_before_discount || 0)
        amount += item.price_before_discount
        price += totalPrice
      })
    return { amount, price }
  }

  const countฺDiscountTotal = () => {
    let amount = 0
    let price = 0
    formData.products &&
      formData.products.forEach(item => {
        const totalPrice = (item.quantity || 0) * (item.discount || 0)
        amount += item.discount
        price += totalPrice
      })
    return { amount, price }
  }

  const calculateSumary = () => {
    const totalPrice = countTotal().price
    let discount: number = formData?.discount || 0
    const shiipingCost: number = formData?.shipping_cost || 0
    if (formData.discount_type === 'percent') {
      discount = (totalPrice * discount) / 100
    }
    const productPrice: number = totalPrice - discount
    return {
      productPrice,
      total: productPrice + shiipingCost,
    }
  }

  const formatRequestParam = (req: CreateQuotationForm): CreateQuotationReq => {
    const product = [] as ProductQuotationForm[]
    req &&
      req?.products &&
      req?.products?.forEach(item => {
        if (item.sale_item_type === 'none-sku') {
          product.push({
            product_id: item.product_id,
            product_option_id: item.product_option_id,
            quantity: item.quantity,
            price: item.price,
            discount: item.discount || 0,
            price_before_discount: item.price_before_discount,
            current_stock: item.current_stock,
            sale_item_type: item?.sale_item_type || '',
            product_uom_id: item.product_uom_id || 0,
            product_detail: {
              brand: item.brand === '' ? 'อื่นๆ' : item.brand,
              code: item.code,
              picture: '',
              product_option_title: item.title,
              title: item.title,
              unit: item.unit,
            },
          })
        } else {
          const isOverStock = item?.updated_flag === true || item.quantity > item.current_stock
          product.push({
            product_id: item.product_id,
            product_option_id: item.product_option_id,
            quantity: item.quantity,
            discount: item.discount || 0,
            price_before_discount: item.price_before_discount,
            price: item.price,
            current_stock: item.current_stock,
            sale_item_type: isOverStock ? 'overstock' : item?.sale_item_type || '',
            product_uom_id: item.product_uom_id || 0,
          })
        }
      })

    const newReq = {
      customer: {
        name: req.name,
        address: req.address,
        email: req.email,
        tax_address: req.tax_address,
        tax_mobile: req.tax_mobile,
        tax_name: req.tax_name,
        tax_number: req.tax_number,
        is_tax: req.is_tax,
        type: req.type,
        mobile: req.mobile,
      },
      delivery_channel: req.delivery_channel,
      delivery_date: toDateQuery(req.delivery_date),
      discount: req.discount,
      discount_type: req.discount_type,
      issuer: {
        name: req.issuer_name,
        note: req.issuer_note,
      },
      recipient: {
        name: req.recipient_name,
        address: req.recipient_address,
        email: req.recipient_email,
        mobile: req.recipient_mobile,
      },
      shipping_cost: req?.shipping_cost,
      status: 'DRAFT',
      products: product,
      is_tax: req.is_tax,
    } as CreateQuotationReq
    return newReq
  }

  const FooterContent = (
    <Space size="middle" align="baseline">
      {isCreateMode ? (
        <Space size="middle" align="baseline">
          <PrimaryButton
            text="บันทึกแบบร่าง"
            btnType="Cancel"
            onClick={() => {
              setUpdatedStatus(QuotationStatus.DRAFT)
              onCreate(QuotationStatus.DRAFT)
            }}
          />
          <PrimaryButton text="ยืนยันการสร้าง" onClick={onClickCreate} />
        </Space>
      ) : (
        <Space size="middle" align="baseline">
          <PrimaryButton
            text="บันทึกแบบร่าง"
            btnType="Cancel"
            onClick={() => onUpdate(QuotationStatus.DRAFT)}
          />
          <PrimaryButton text="ยืนยันการสร้าง" onClick={onClickCreate} />
        </Space>
      )}
    </Space>
  )

  const isProductError = isError('products') || isError('products_wrong') || isError('stock_wrong')
  let errorMsg = ''
  if (isProductError) {
    if (isError('products')) {
      errorMsg = 'กรุณาระบุ สินค้าอย่างน้อย 1 รายการ'
    } else if (isError('products_wrong')) {
      errorMsg = 'กรุณาระบุ ข้อมูลสินค้าให้ถูกต้อง'
    } else if (isError('stock_wrong')) {
      errorMsg = 'กรุณาระบุ จำนวนสินค้าให้ถูกต้องตามสต๊อกคงเหลือ'
    }
  }

  const data = formatRequestParam(formData)
  const isOverStock = data && data.products && data.products.find(item => item.sale_item_type === 'overstock')

  const renderConfirmDescription = () => {
    return (
      <div>
        <div>
          เมื่อทำการยืนยันสร้างใบเสนอราคา คุณจะไม่สามารถแก้ไขข้อมูลในใบเสนอราคาได้
          และจำนวนสต๊อกของสินค้าจะถูกตัดออกไว้สำหรับใบเสนอราคานี้ กรุณาตรวจสอบความถูกต้องก่อนกดปุ่มยืนยัน
        </div>
        {isOverStock && (
          <Warning>
            <div>
              แจ้งเตือน!! คุณระบุจำนวนสั่งซื้อสินค้าเกินจำนวนสต๊อกคงเหลือ
              กรณียืนยันทำรายการขายเกินสต๊อกจะมีผลดังนี้
            </div>
            <div>1. ระบบจะสร้างรายการขายได้ตามปกติ</div>
            <div>2. ระบบจะไม่ทำการตัดจำนวนสต๊อกสินค้าของรายการที่ขายเกินสต๊อก</div>
            <div>
              <RowTileGrey>
                ข้อแนะนำ : เพื่อให้ข้อมูลจำนวนสต๊อกคงเหลือและต้นทุนรายการขายถูกต้องสมบูรณ์
                คุณสามารถดำเนินการรับเข้าสินค้าและปรับสินค้าออกตามจำนวนขายได้ในภายหลัง
              </RowTileGrey>
            </div>
          </Warning>
        )}
      </div>
    )
  }

  const renderProductName = (val: string, record: QuotationProduct) => {
    const isSameTitle = record.title == record.product_option_title
    return (
      <>
        <RowTile>{record.title}</RowTile>
        {!isSameTitle && <ProductDesc>{record.product_option_title}</ProductDesc>}
        <ProductError>{record?.message}</ProductError>
      </>
    )
  }

  const renderStock = (quantity: number, record: QuotationProduct) => {
    return quantity <= 10 ? (
      <div>
        <StockMin>{numberWithComma(quantity)}</StockMin>
      </div>
    ) : (
      numberWithComma(quantity)
    )
  }

  const productWarningColumn = [
    {
      title: 'รหัสสินค้า',
      dataIndex: 'code',
      key: 'code',
      width: '100px',
    },
    {
      title: 'ชื่อสินค้า',
      dataIndex: 'title',
      key: 'title',
      render: renderProductName,
    },
    {
      title: 'ยี่ห้อ',
      dataIndex: 'brand',
      key: 'brand',
    },
    {
      title: 'หน่วย',
      dataIndex: 'unit',
      key: 'unit',
    },
    {
      title: 'สต๊อกคงเหลือ',
      dataIndex: 'current_stock',
      key: 'current_stock',
      render: renderStock,
    },
    // {
    //   title: 'จำนวนสินค้าที่ถูกใช้',
    //   dataIndex: 'current_stock',
    //   key: 'current_stock',
    //   render: renderStock,
    // },
    // {
    //   title: 'จำนวนสินค้าพร้อมขาย',
    //   dataIndex: 'current_stock',
    //   key: 'current_stock',
    //   render: renderStock,
    // },
    {
      title: 'จำนวนสั่งซื้อ',
      dataIndex: 'quantity',
      key: 'quantity',
      render: (val: number) => numberWithComma(val),
    },
  ]

  const getUpdatedDatas = (products: QuotationProduct[]) => {
    const result = products?.filter(item => item.updated_flag === true)
    return result || []
  }

  const renderWarningDescription = () => {
    return (
      <div>
        <DescriptionWrapper>
          <TableListPage
            rowKey="product_option_id"
            tableName="product-purchase"
            columns={productWarningColumn}
            datas={getUpdatedDatas(formData?.products || [])}
            size={'small'}
            scrollX={600}
          />
          รายการสินค้าคงเหลือปัจจุบัน ณ. {currentDateTime()}
          <br />
          <Warning>
            <div>
              แจ้งเตือน!! คุณระบุจำนวนสั่งซื้อสินค้าเกินจำนวนสต๊อกคงเหลือ
              กรณียืนยันทำรายการขายเกินสต๊อกจะมีผลดังนี้
            </div>
            <div>1. ระบบจะสร้างรายการขายได้ตามปกติ</div>
            <div>2. ระบบจะไม่ทำการตัดจำนวนสต๊อกสินค้าของรายการที่ขายเกินสต๊อก</div>
            <div>
              <RowTileGrey>
                ข้อแนะนำ : เพื่อให้ข้อมูลจำนวนสต๊อกคงเหลือและต้นทุนรายการขายถูกต้องสมบูรณ์
                คุณสามารถดำเนินการรับเข้าสินค้าและปรับสินค้าออกตามจำนวนขายได้ในภายหลัง
              </RowTileGrey>
            </div>
          </Warning>
        </DescriptionWrapper>
      </div>
    )
  }

  const ConfirmCreateModal = (
    <ConfirmDailog
      title="ยืนยันการสร้างใบเสนอราคา?"
      description={renderConfirmDescription()}
      confirmBtnTxt="ยืนยัน"
      isShow={confirmCreateDialog}
      handleOk={onConfirmCreate}
      handleCancel={() => setConfirmCreateDialog(false)}
    />
  )

  const ConfirmChangeOverModal = (
    <ConfirmWithChild
      title={rejectData?.message || `พบจำนวนสต๊อกของสินค้าบางรายการมีการเปลี่ยนแปลง!`}
      child={renderWarningDescription()}
      confirmBtnTxt={
        updatedStatus === QuotationStatus.DRAFT ? `ยืนยันบันทึกแบบร่าง` : `ยืนยันขายสินค้านอกสต๊อก`
      }
      cancelBtnTxt="กลับไปแก้ไขข้อมูล"
      isShow={warningOverstockDialog}
      handleOk={onRetryCreate}
      handleCancel={() => {
        resetUpdatedFlag()
        setWarningOverstockDialog(false)
      }}
      width={'900px'}
    />
  )

  const renderTitle = () => {
    return (
      <DetailHeader
        id={id}
        purchasing_no={detail?.quotation_no}
        isCreateMode={isCreateMode}
        detail={detail}
      />
    )
  }

  const customerInfo = () => {
    return (
      <BoxWrapper>
        <Row justify="start" gutter={[16, 0]} align="middle">
          <Col md={24} xs={24}>
            <BoxTitle>ข้อมูลลูกค้า</BoxTitle>
          </Col>
          <Col md={12} xs={24}>
            <AppSelect
              name="type"
              label="เลือกลูกค้า/คู่ค้า"
              placeHolder="ค้นหาชื่อเบอร์โทร หรือชื่อลูกค้า/คู่ค้า"
              isRequired={isRequired('mobile')}
              isError={isError('mobile')}
              value={formData?.mobile ? formData?.mobile : null}
              onChange={onSelectCustomer}
              // menu={getPriceConfigsMenuSelect(configs?.value?.price_labels || [], 'value', 'name')}
              menu={getCustomerMenuSelect(customers, 'name', 'mobile', true)}
              allowClear={false}
            />
          </Col>
          <Col md={12} xs={24}></Col>
          <Col md={12} xs={24}>
            <AppInput
              name="name"
              label="ชื่อลูกค้า"
              isRequired={isRequired('name')}
              isError={isError('name')}
              value={formData.name}
              onChange={onUpdateData}
              resProps={{ disabled: true }}
            />
          </Col>
          <Col md={12} xs={24}>
            <AppInput
              name="mobile"
              label="เบอร์โทรศัพท์"
              isRequired={isRequired('mobile')}
              isError={isError('mobile') || draftFormError.includes('mobile')}
              value={formData.mobile}
              onChange={onUpdateData}
              resProps={{ disabled: true }}
            />
          </Col>
          {/* <Col md={12} xs={24}>
            {formData.mobile && formData.mobile.length >= 9 && (
              <Space>
                <PrimaryButton
                  btnType="Cancel"
                  text="ค้นหา"
                  icon={<SearchOutlined />}
                  onClick={() => onGetCustomer(formData.mobile)}
                />
              </Space>
            )}
          </Col> */}
          {/* <Col md={12} xs={24}>
            <AppInput
              name="name"
              label="ชื่อลูกค้า"
              placeHolder="ระบุชื่อ-นามสกุล"
              isRequired={isRequired('name')}
              isError={isError('name')}
              value={formData.name}
              onChange={onUpdateData}
            />
          </Col> */}
          <Col md={12} xs={24}>
            <AppInput
              name="email"
              label="อีเมล"
              resProps={{ disabled: true }}
              errorMsg={isError('email_format') ? 'รูปแบบอีเมลให้ถูกต้อง' : 'อีเมล'}
              isRequired={isRequired('email')}
              isError={isError('email') || isError('email_format')}
              value={formData.email}
              onChange={onUpdateData}
              specialRequired={true}
            />
          </Col>
          <Col md={12} xs={24}>
            <AppInput
              label="ที่อยู่"
              isRequired={isRequired('address')}
              isError={isError('address')}
              name="address"
              value={formData.address}
              onChange={onUpdateData}
              resProps={{ disabled: true }}
            />
          </Col>
          <Col md={12} xs={24}>
            <AppSelect
              name="type"
              label="ประเภทลูกค้า"
              placeHolder="เลือกประเภทลูกค้า"
              isRequired={isRequired('type')}
              isError={isError('type')}
              value={formData?.type}
              onChange={onUpdateData}
              menu={getPriceConfigsMenuSelect(configs?.value?.price_labels || [], 'value', 'name')}
              allowClear={false}
              disabled={true}
            />
          </Col>
          <Col md={24} xs={24}>
            <Checkbox
              checked={formData?.is_tax || false}
              onChange={e => onUpdateData(e.target.checked, 'is_tax')}
              value={formData?.is_tax}
            >
              ขอใบกำกับภาษีรูปแบบเต็ม{' '}
            </Checkbox>
            {isExcludeVat && (
              <WarningTax>
                หากลูกค้าต้องการขอใบกำกับภาษีรูปแบบเต็ม ระบบจะคำนวนภาษีมูลค่าเพิ่ม 7% จากราคาสินค้า
              </WarningTax>
            )}
          </Col>
          {formData?.is_tax && (
            <>
              <Col md={24} xs={24}>
                <br />
                <Row justify="space-between">
                  <Col>
                    <BoxTitle>ข้อมูลสำหรับออกใบกำกับภาษีรูปแบบเต็ม</BoxTitle>
                  </Col>
                  {/* <Col>
                    <MyLinkText onClick={onCopyCustomerDataToTax}>คัดลอกจากข้อมูลลูกค้า</MyLinkText>
                  </Col> */}
                </Row>
              </Col>
              <Col md={12} xs={24}>
                <AppInput
                  name="tax_name"
                  label="ชื่อ"
                  placeHolder="ระบุชื่อ-นามสกุล"
                  isRequired={true}
                  isError={isError('tax_name')}
                  value={formData.tax_name}
                  onChange={onUpdateData}
                  // resProps={{ disabled: true }}
                />
              </Col>
              <Col md={12} xs={24}>
                <AppInput
                  name="tax_number"
                  label="เลขประจำตัวผู้เสียภาษี"
                  isRequired={true}
                  isError={isError('tax_number')}
                  value={formData.tax_number}
                  onChange={onUpdateData}
                  //resProps={{ disabled: true }}
                />
              </Col>
              <Col md={12} xs={24}>
                <AppInput
                  name="tax_mobile"
                  label="เบอร์โทรศัพท์"
                  isRequired={false}
                  isError={isError('tax_mobile')}
                  value={formData.tax_mobile}
                  onChange={onUpdateData}
                  // resProps={{ disabled: true }}
                />
              </Col>
              <Col md={12} xs={24}>
                <AppInput
                  label="ที่อยู่"
                  isRequired={true}
                  isError={isError('tax_address')}
                  name="tax_address"
                  value={formData.tax_address}
                  onChange={onUpdateData}
                  //resProps={{ disabled: true }}
                />
              </Col>
            </>
          )}
        </Row>
      </BoxWrapper>
    )
  }

  const cutomerDeliveryInfo = () => {
    return (
      <BoxWrapper>
        <Row justify="space-between" gutter={[16, 0]}>
          <Col md={12} xs={24}>
            <BoxTitle>ข้อมูลที่อยู่ผู้รับ</BoxTitle>
          </Col>
          <Col>
            <MyLinkText onClick={onCopyCustomerData}>คัดลอกจากข้อมูลลูกค้า</MyLinkText>
          </Col>
          <Col md={24} xs={24}>
            <AppInput
              name="recipient_name"
              label="ชื่อลูกค้า"
              placeHolder="ระบุชื่อ-นามสกุล"
              isRequired={isRequired('recipient_name')}
              isError={isError('recipient_name')}
              value={formData.recipient_name}
              onChange={onUpdateData}
            />
          </Col>
          <Col md={24} xs={24}>
            <AppInput
              name="recipient_mobile"
              label="เบอร์โทรศัพท์"
              isRequired={isRequired('recipient_mobile')}
              isError={isError('recipient_mobile')}
              value={formData.recipient_mobile}
              onChange={onUpdateData}
            />
          </Col>
          <Col md={24} xs={24}>
            <AppInput
              name="recipient_email"
              label="อีเมล"
              errorMsg={isError('recipient_email_format') ? 'รูปแบบอีเมลให้ถูกต้อง' : 'อีเมล'}
              isRequired={isRequired('recipient_email')}
              isError={isError('recipient_email') || isError('recipient_email_format')}
              value={formData.recipient_email}
              onChange={onUpdateData}
              specialRequired={true}
            />
          </Col>
          <Col md={24} xs={24}>
            <AppTextArea
              label="ที่อยู่"
              isRequired={isRequired('recipient_address')}
              isError={isError('recipient_address')}
              name="recipient_address"
              value={formData.recipient_address}
              onChange={onUpdateData}
              rows={2}
            />
          </Col>
        </Row>
      </BoxWrapper>
    )
  }

  const deliveryInfo = () => {
    return (
      <BoxWrapper>
        <Row justify="space-between" gutter={[16, 0]}>
          <Col md={12} xs={24}>
            <BoxTitle>ข้อมูลการจัดส่ง</BoxTitle>
          </Col>
          <Col md={24} xs={24}>
            <AppDateItem
              label="วันที่ต้องการให้จัดส่ง"
              placeHolder={'วันที่ต้องการจัดส่ง'}
              isRequired={isRequired('delivery_date')}
              isError={isError('delivery_date')}
              onChange={(date: string) => onUpdateData(date, 'delivery_date')}
              date={formData.delivery_date}
              disableDate={(date: any) => {
                return isAfter(
                  moment(date)
                    .subtract(-1, 'days')
                    .startOf('day')
                    .toString(),
                )
              }}
            />
          </Col>
          <Col md={24} xs={24}>
            <AppSelect
              name="delivery_channel"
              label="ช่องทางจัดส่ง"
              placeHolder="ช่องทางจัดส่ง"
              isRequired={isRequired('delivery_channel')}
              isError={isError('delivery_channel')}
              value={formData.delivery_channel}
              onChange={onUpdateData}
              menu={menuQuotationDeliveryType}
            />
          </Col>
          {/* <Col md={24} xs={24}>
            <BoxTitle>ข้อมูลผู้ทำรายการ</BoxTitle>
          </Col> */}
          <Col md={24} xs={24}>
            <AppInput
              name="issuer_name"
              label="ผู้ออกใบเสนอราคา"
              isRequired={isRequired('issuer_name')}
              isError={isError('issuer_name')}
              value={formData.issuer_name}
              onChange={onUpdateData}
            />
          </Col>
          <Col md={24} xs={24}>
            <AppTextArea
              label="หมายเหตุ (ถ้ามี)"
              placeHolder="ระบุหมายเหตุ"
              isRequired={isRequired('issuer_note')}
              isError={isError('issuer_note')}
              name="issuer_note"
              rows={2}
              value={formData.issuer_note}
              onChange={onUpdateData}
            />
          </Col>
        </Row>
      </BoxWrapper>
    )
  }

  const total = calculateSumary().productPrice

  const calculateVat = () => {
    if (isExcludeVat) {
      if (!formData?.is_tax) {
        return { vat7: 0, total_amount: total }
      }
      const vat7 = (7 * total) / 100
      const total_amount = total + vat7
      return { vat7, total_amount }
    } else {
      if (!formData?.is_tax && !showVat) {
        return { vat7: 0, total_amount: total }
      }
      const priceExcludeVat = (total * 100) / (100 + 7)
      const vat7 = priceExcludeVat * (7 / 100)
      return { vat7, total_amount: total }
    }
  }

  const summaryFooter = () => {
    return (
      <>
        <Row justify="end">
          <Col>
            <Space align="end">
              <InfoTitle>รวมราคาสินค้าก่อนหักส่วนลด</InfoTitle>
              <InputWidthMax>
                <Price> {numberWithComma(countฺBeforeDiscountTotal().price, true)} บาท </Price>
              </InputWidthMax>
            </Space>
          </Col>
        </Row>
        <Row justify="end">
          <Col>
            <Space align="end">
              <InfoTitle>หัก ส่วนลดสินค้า</InfoTitle>
              <InputWidthMax>
                <Price> {numberWithComma(countฺDiscountTotal().price, true)} บาท </Price>
              </InputWidthMax>
            </Space>
          </Col>
        </Row>
        <Row justify="end">
          <Col>
            <Space align="end">
              <InfoTitle>รวมราคาสินค้า</InfoTitle>
              <InputWidthMax>
                <Price> {numberWithComma(countTotal().price, true)} บาท </Price>
              </InputWidthMax>
            </Space>
          </Col>
        </Row>
        <Row justify="end">
          <Col>
            <Space align="baseline" size="small">
              <InfoTitle>ส่วนลดท้ายบิล</InfoTitle>
              <InputWidth>
                <AppInput
                  name="discount"
                  label=""
                  placeHolder="ระบุจำนวน"
                  isRequired={true}
                  isError={false}
                  value={formData.discount}
                  onChange={onUpdateData}
                  type="number"
                />
              </InputWidth>
              <InputWidthMin>
                <AppSelect
                  name="discount_type"
                  label=""
                  placeHolder="ประเภทส่วนลด"
                  isRequired={false}
                  isError={false}
                  value={formData.discount_type}
                  onChange={onUpdateData}
                  menu={menuDiscountType}
                  allowClear={false}
                />
              </InputWidthMin>
            </Space>
          </Col>
        </Row>

        {formData?.is_tax && isExcludeVat && (
          <Row justify="end">
            <Col>
              <Space align="baseline">
                <InfoTitle>ราคารวมทั้งสิ้น</InfoTitle>
                <InputWidthMax>
                  <Price>{numberWithComma(calculateSumary().productPrice, true)} บาท</Price>
                </InputWidthMax>
              </Space>
            </Col>
          </Row>
        )}
        {(formData?.is_tax || (showVat && !isExcludeVat)) && (
          <Row justify="end">
            <Col>
              <Space align="baseline">
                <InfoTitle>
                  ภาษีมูลค่าเพิ่ม 7% ({isExcludeVat ? VAT_TYPE_TEXT.EX : VAT_TYPE_TEXT.IN})
                </InfoTitle>
                <InputWidthMax>
                  <Price>{numberWithComma(calculateVat().vat7, true)} บาท</Price>
                </InputWidthMax>
              </Space>
            </Col>
          </Row>
        )}
        <Row justify="end">
          <Col>
            <Space align="baseline">
              <InfoTitle>ค่าจัดส่งที่เรียกเก็บจากลูกค้า</InfoTitle>
              <InputWidthMax>
                <AppInput
                  name="shipping_cost"
                  label=""
                  placeHolder="ระบุจำนวน"
                  isRequired={true}
                  isError={false}
                  value={formData.shipping_cost}
                  onChange={onUpdateData}
                  resProps={{ suffix: 'บาท' }}
                  type="number"
                />
              </InputWidthMax>
            </Space>
          </Col>
        </Row>
        <Row justify="end">
          <Col>
            <Space align="baseline">
              <InfoTitle>จำนวนเงินรวมทั้งสิ้น</InfoTitle>
              <InputWidthMax>
                <Price>
                  {numberWithComma(calculateVat().total_amount + (formData.shipping_cost || 0), true)} บาท
                </Price>
              </InputWidthMax>
            </Space>
          </Col>
        </Row>
      </>
    )
  }

  return (
    <DetailDrawer
      title={renderTitle()}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={FooterContent}
      width={'95%'}
    >
      <LoadingView isShow={detailEvent.IsLoading} />
      <EventModal event={[event]} enable={true} successCalback={onEventSuccess} errorCalback={clearEvent} />
      {ConfirmCreateModal}
      {ConfirmChangeOverModal}
      <Row justify="space-between" gutter={16}>
        <Col md={24} xs={24}>
          {customerInfo()}
        </Col>
        <Divider />
        <Col md={24} xs={24}>
          <BoxTitle>รายการสินค้า</BoxTitle>
        </Col>
        <Col md={24} xs={24}>
          <ProductsTable
            products={formData?.products || []}
            onUpdateData={(product: QuotationProduct[]) => {
              onUpdateData(product, 'products')
            }}
            customerType={formData?.type}
            quotationPdfRef={quotationPDF}
            quotationLitePdfRef={quotationLitePDF}
            detail={detail}
            isFranchise={isFranchise}
            hasNoneskuPermission={hasNoneskuPermission}
            hasOverstockPermission={hasOverstockPermission}
            hasProductDiscount={hasProductDiscount}
          />
          <FormItem label="" status={isProductError} error={errorMsg}>
            <span></span>
          </FormItem>
        </Col>
        <Col md={24} xs={24}>
          {summaryFooter()}
        </Col>

        <Divider />
        <Col md={12} xs={24}>
          {cutomerDeliveryInfo()}
        </Col>
        <Col md={12} xs={24}>
          {deliveryInfo()}
        </Col>
        {/* <Col md={24} xs={24}>
          <BoxTitle>ข้อมูลผู้ทำรายการ</BoxTitle>
        </Col>
        <Col md={12} xs={24}>
          <AppInput
            name="issuer_name"
            label="ผู้ออกใบเสนอราคา"
            isRequired={isRequired('issuer_name')}
            isError={isError('issuer_name')}
            value={formData.issuer_name}
            onChange={onUpdateData}
          />
        </Col>
        <Col md={12} xs={24}>
          <AppTextArea
            label="หมายเหตุ (ถ้ามี)"
            placeHolder="ระบุหมายเหตุ"
            isRequired={isRequired('issuer_note')}
            isError={isError('issuer_note')}
            name="issuer_note"
            rows={2}
            value={formData.issuer_note}
            onChange={onUpdateData}
          />
        </Col> */}
        <Row ref={quotationPDF}>
          <Col span={24}>
            <QuotationPDF detail={detail} showVat={showVat} configData={configDataQu} />
          </Col>
        </Row>
        <Row ref={quotationLitePDF}>
          <Col span={24}>
            <QuotationPDF detail={detail} isLite={true} showVat={showVat} configData={configDataQu} />
          </Col>
        </Row>
      </Row>
    </DetailDrawer>
  )
}

const BoxTitle = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  margin-bottom: 5px;
`

const BoxWrapper = styled.div`
  width: 100%;
  border-radius: 10px;
  padding: 15px 10px;
  //border: 1px solid ${(props: { theme: MyTheme }): string => props.theme.colors.whitebg};
  border: 1px solid #f0f0f0;
  margin-bottom: 10px;
  background-color:  ${(props: { theme: MyTheme }): string => props.theme.colors.white};
`

const DescriptionWrapper = styled.div`
  text-align: left;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const InfoTitle = styled.span`
  // font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  margin-right: 20px;
`

const InputWidthMin = styled.div`
  width: 80px;
`

const InputWidth = styled.div`
  width: 140px;
`

const InputWidthMax = styled.div`
  width: 230px;
`

const MyLinkText: any = styled(LinkText)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
`

const Price = styled.div`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.regular};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.title2};
  text-align: right;
  margin-bottom: 10px;
`

const Warning = styled.div`
  padding-top: 20px;
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  text-align: left;
`

const RowTile = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const RowTileGrey = styled(RowTile)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
`

const ProductDesc = styled(RowTile)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const ProductError = styled(ProductDesc)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
`

const StockMin = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
`

const WarningTax = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
  padding-left: 25px;
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectQuotationActionEvent(state),
    detail: selectQuotationDetail(state),
    detailEvent: selectQuotationDetailEvent(state),
    supplierList: selectAllSupplierList(state),
    configs: selectDatas(state),
    customers: selectAllSaleOrderCustomerList(state),
    rejectData: selectRejectData(state),
    configList: selectConfigList(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(QuotationDetailForm)
